export default "__VITE_ASSET__oFT5F1iR__"